import React from 'react';

export default function GalleryPage() {
  const photos = [
    'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600',
    'https://images.unsplash.com/photo-1571210862729-78a52d3779a2?w=600',
    'https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600',
    'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600',
    'https://images.unsplash.com/photo-1565084888279-aca607bb8427?w=600',
    'https://images.unsplash.com/photo-1588072432836-e10032774350?w=600',
    'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=600',
    'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600',
    'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=600',
  ];
  return (
    <>
      <div className="page-hero">
        <h2>Photo Gallery</h2>
        <p>Glimpses of joy, learning and memories at our school</p>
      </div>
      <section className="gallery" style={{paddingTop:'70px'}}>
        <div className="container">
          <div className="gallery-grid">
            {photos.map((src,i) => (
              <div className="gallery-item" key={i}>
                <img src={src} alt={`Gallery ${i+1}`}/>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
